export default {
  // $vuexSetUserInfo (state, info) {
  //   state.user = info._id
  //   state.userInfo = info
  // },

  $vuexSetCartItem(state, item) {
    var pic = 0;
    if (
      item.name === "皇牌1人1款自選套餐" ||
      item.name === "聖誕歡樂1人1款套餐"
    ) {
      for (var i in item.selected_items) {
        for (var j = 1; j < item.selected_items[i].length; j = j + 2) {
          pic =
            pic +
            item.selected_items[i][j].price * item.selected_items[i][j].number;
        }
      }
      item.prices = pic;
    }
    state.cartItems.push(item);
    window.localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
  },

  $vuexUpdateCartItem(state, { item, event }) {
    item.quantity = event;
    const index = state.cartItems.indexOf(item);
    // eslint-disable-next-line no-undef
    vm.$set(state.cartItems, index, item);
    window.localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
  },

  $vuexRemoveCartItem(state, item) {
    const index = state.cartItems.indexOf(item);
    state.cartItems.splice(index, 1);
    window.localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
  }
};
